export default class Constants {
  static readonly LISTA_DE_RAMO_DE_ATIVIDADE = [
    'Indústria',
    'Comércio',
    'Serviços',
  ];

  static readonly BASE_URL = '';

  static readonly LISTA_STATUS = [
    'Ativo',
    'Inativo',
  ];

  static readonly LISTA_DE_ESTADOS = [
    {
      sigla: 'AC',
      nome: 'Acre',
    },
    {
      sigla: 'AL',
      nome: 'Alagoas',
    },
    {
      sigla: 'AP',
      nome: 'Amapá',
    },
    {
      sigla: 'AM',
      nome: 'Amazonas',
    },
    {
      sigla: 'BA',
      nome: 'Bahia',
    },
    {
      sigla: 'CE',
      nome: 'Ceará',
    },
    {
      sigla: 'DF',
      nome: 'Distrito Federal',
    },
    {
      sigla: 'ES',
      nome: 'Espírito Santo',
    },
    {
      sigla: 'GO',
      nome: 'Goiás',
    },
    {
      sigla: 'MA',
      nome: 'Maranhão',
    },
    {
      sigla: 'MT',
      nome: 'Mato Grosso',
    },
    {
      sigla: 'MS',
      nome: 'Mato Grosso do Sul',
    },
    {
      sigla: 'MG',
      nome: 'Minas Gerais',
    },
    {
      sigla: 'PA',
      nome: 'Pará',
    },
    {
      sigla: 'PB',
      nome: 'Paraíba',
    },
    {
      sigla: 'PR',
      nome: 'Paraná',
    },
    {
      sigla: 'PE',
      nome: 'Pernambuco',
    },
    {
      sigla: 'PI',
      nome: 'Piauí',
    },
    {
      sigla: 'RJ',
      nome: 'Rio de Janeiro',
    },
    {
      sigla: 'RN',
      nome: 'Rio Grande do Norte',
    },
    {
      sigla: 'RS',
      nome: 'Rio Grande do Sul',
    },
    {
      sigla: 'RO',
      nome: 'Rondônia',
    },
    {
      sigla: 'RR',
      nome: 'Roraima',
    },
    {
      sigla: 'SC',
      nome: 'Santa Catarina',
    },
    {
      sigla: 'SP',
      nome: 'São Paulo',
    },
    {
      sigla: 'SE',
      nome: 'Sergipe',
    },
    {
      sigla: 'TO',
      nome: 'Tocantins',
    },
  ];

  static readonly LISTA_COLUNAS_CLIENTES = [
    'Nome/Fantasia',
    'CPF/CNPJ',
    'Razão Social',
    'Ramo Atividade',
    'Status',
  ];

  static readonly LISTA_COLUNAS_PRODUTOS = [
    'Nome',
    'Descrição',
    'Valor',
    'Valor implantação',
  ];

  static readonly LISTA_COLUNAS_COLABORADORES = [
    'Nome',
    'Email',
    'Telefone',
    'Empresa',
  ];

  static readonly LISTA_COLUNAS_NEGOCIOS = [
    'ID',
    'Descrição',
    'Contato',
    'Fase',
    'Data Início',
    'Previsão',
    'Data Fechamento',
    'Status',
    'Valor',
    'Observação'
  ];

}
